module.exports = {"140402001":"东街街道","140402002":"西街街道","140402003":"英雄南路街道","140402004":"英雄中路街道","140402005":"紫金街街道","140402006":"太行东街街道","140402007":"太行西街街道","140402008":"延安南路街道","140402009":"常青街道","140402010":"五马街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140402.json
// module id = 377
// module chunks = 0